module.exports = __webpack_public_path__ + "static/media/black-friday.99f204ca.svg";